const objectWithClassName = (style) => style;
const objectFromString = (cssString) => {
  if (!cssString || typeof cssString !== "string") {
    return {};
  }
  return cssString.split(";").filter((style) => style.trim()).reduce((acc, declaration) => {
    const [property, value] = declaration.split(":").map((str) => str.trim());
    if (!property || !value) {
      return acc;
    }
    const camelProperty = property.replace(
      /-([a-z])/g,
      (g) => g[1].toUpperCase()
    );
    const processedValue = value.match(/^\d+$/) ? parseInt(value, 10) : value.match(/^\d*\.\d+$/) ? parseFloat(value) : value;
    return {
      ...acc,
      [camelProperty]: processedValue
    };
  }, {});
};
export {
  objectFromString,
  objectWithClassName
};
//# sourceMappingURL=jss.js.map
